export default __webpack_public_path__ + "static/media/teaser-etalinepro-fr.5c086694.png";